export default {
    ca: {
        title: 'Mapes destacats',
    },
    es: {
        title: 'Mapas destacados',
    },
    en: {
        title: 'Featured maps',
    },
};



// WEBPACK FOOTER //
// ./src/home/components/items-slider/items-slider-translations.js